import { useSuspenseQuery } from "@tanstack/react-query";
import { dashboardBestSellingApi } from "@/features/dashboard/features/best-selling-section/api";
import { BestSellingRequestParams } from "@/features/dashboard/features/best-selling-section/types";

const useGetBestSellingProducts = (params: BestSellingRequestParams) => {
  const { data: bestSellingProducts } = useSuspenseQuery({
    queryKey: ["dashboard", "best-selling-products", params],
    queryFn: () => dashboardBestSellingApi.getBestSellingProducts(params),
    select: (data) => data.data.slice(0, 1000),
  });

  return { bestSellingProducts };
};

export default useGetBestSellingProducts;
